import { useEffect, useState } from 'react';

import { Box, Grid, Typography } from '@mui/material';

import { useDispatch, useSelector } from 'react-redux';
import { getSecondLevelProducts } from 'store/slices/healthContent';
import { DefaultRootStateProps } from 'types';
import CardRatings from '../Images/CardRatings';
import TableProducts from '../TableProducts';
import { useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { ResumenProducts } from 'types/components/shared';
import { HeaderWrapperView } from '../components/CardWrapper';
import ViewGridComponent from '../components/ViewGrid';

const Products = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const [secondLevel, setSecondLevel] = useState<any>();
    const [typeScore, setTypeScore] = useState<'Good' | 'Fair' | 'Poor' | string>('');
    const [products, setProducts] = useState([]);
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const { secondLevelProducts, loading } = useSelector((state: DefaultRootStateProps) => state.healthContent);

    const intl = useIntl();

    useEffect(() => {
        const idMerchant = new URLSearchParams(location.search).get('idMerchant');
        dispatch(getSecondLevelProducts(Number(idMerchant) ?? 0));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    useEffect(() => {
        setSecondLevel(secondLevelProducts);
    }, [secondLevelProducts]);

    useEffect(() => {
        if (typeScore === 'Good') {
            setProducts(secondLevel?.metricsGood);
        } else if (typeScore === 'Fair') {
            setProducts(secondLevel?.metricsFair);
        } else if (typeScore === 'Poor') {
            setProducts(secondLevel?.metricsPoor);
        } else {
            setProducts(secondLevel?.metricsGood);
        }
    }, [secondLevel?.metricsFair, secondLevel?.metricsGood, secondLevel?.metricsPoor, typeScore]);

    const sumaValores = () => {
        let suma = 0;
        suma =
            secondLevel.resumeProducts[0]?.totalProducts +
            secondLevel.resumeProducts[1]?.totalProducts +
            secondLevel.resumeProducts[2]?.totalProducts;
        return suma;
    };
    return (
        <>
            <HeaderWrapperView title={intl.formatMessage({ id: 'products' })} dataToDownload={secondLevelProducts} />

            <ViewGridComponent isLoading={loading && !secondLevel?.resume?.length}>
                {secondLevel?.resumeProducts
                    ?.toSorted((a: ResumenProducts, b: ResumenProducts) => a.metricConfigRangeId - b.metricConfigRangeId)
                    .map((resume: ResumenProducts) => (
                        <Grid item xs={12} sm={4} lg={12}>
                            <CardRatings resume={resume} sumaValores={sumaValores} setTypeScore={setTypeScore} typeScore={typeScore} />
                        </Grid>
                    ))}
                {products?.length === 0 ? (
                    <Box sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Typography variant="h3">No Products to show</Typography>
                    </Box>
                ) : (
                    <TableProducts products={products} typeReq="products" />
                )}
            </ViewGridComponent>
            {/* {loading && !secondLevel?.resume?.length ? (
                <Fade in={loading}>
                    <Grid container display={'flex'} spacing={2}>
                        <Grid item xs={12} lg={4}>
                            <Skeleton variant="rectangular" height={140} sx={{ borderRadius: '10px' }} />
                            <Skeleton variant="rectangular" height={140} sx={{ borderRadius: '10px', mt: 2 }} />
                            <Skeleton variant="rectangular" height={140} sx={{ borderRadius: '10px', mt: 2 }} />
                        </Grid>
                        <Grid item xs={12} xl={8}>
                            <Skeleton variant="rectangular" height={700} sx={{ borderRadius: '10px', ml: 2 }} />
                        </Grid>
                    </Grid>
                </Fade>
            ) : (
                <Grid
                    container
                    direction="row"
                    xs={12}
                    spacing={{
                        xs: 0,
                        md: 2
                    }}
                    rowSpacing={2}
                >
                    <Grid item xs={12} xl={4}>
                        <Grid container spacing={2} sx={{ alignItems: 'stretch' }}>
                            {secondLevel?.resumeProducts
                                ?.toSorted((a: ResumenProducts, b: ResumenProducts) => a.metricConfigRangeId - b.metricConfigRangeId)
                                .map((resume: ResumenProducts) => (
                                    <Grid item xs={12} sm={4} lg={12}>
                                        <CardRatings
                                            resume={resume}
                                            sumaValores={sumaValores}
                                            setTypeScore={setTypeScore}
                                            typeScore={typeScore}
                                        />
                                    </Grid>
                                ))}
                        </Grid>
                    </Grid>
                    <Grid item xs={12} xl={8}>
                        {products?.length === 0 ? (
                            <Box sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Typography variant="h3">No Products to show</Typography>
                            </Box>
                        ) : (
                            <TableProducts products={products} typeReq="products" />
                        )}
                    </Grid>
                </Grid>
            )} */}
        </>
    );
};

export default Products;
